import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  configManager,
  useCrudEditContext,
  RESOURCE_ACTION_EDIT,
  RESOURCE_ACTION_CREATE
} from '@unicus/react-ui-kit';
import PageContainer from './PageContainer';
import ResourceErrorAlert from './ResourceErrorAlert';

const PageEdit = ({
  children,
  cancelEdit,
  post,
  update,
  visible,
  action,
  data,
  size = 'sm',
  resource,
  submit,
  onSubmit,
  onBeforeBinding,
  updateFormOnDataChanged = true,
  readOnly = false,
  onDataChanged,
  onValuesChange,
  showConfirmDataLoss = true,
  onCreateOrUpdateSuccess,
  ...rest
}) => {
  const { form: editingForm } = useCrudEditContext();
  const [modified, setModified] = useState(false);

  useEffect(() => {
    const dataChanged = onBeforeBinding ? onBeforeBinding(data) : data;
    if (updateFormOnDataChanged) {
      editingForm.setFieldsValue(dataChanged);
    }
    if (onDataChanged) {
      onDataChanged(dataChanged);
    }
  }, [updateFormOnDataChanged, data]);

  const handleSubmit = () => {
    if (!action) {
      action = data.id ? RESOURCE_ACTION_EDIT : RESOURCE_ACTION_CREATE;
    }

    editingForm.validateFields().then((values) => {
      let dataToSend = { ...data, ...values };

      if (onSubmit) {
        dataToSend = onSubmit(dataToSend);
        if (!dataToSend) {
          return;
        }
      }
      if (submit) {
        submit(values, action);
      } else if (action === RESOURCE_ACTION_EDIT) {
        update(data.id, dataToSend, onCreateOrUpdateSuccess);
      } else {
        post(dataToSend, onCreateOrUpdateSuccess);
      }
    });
  };

  const handleValuesChange = (changedValues, allValues) => {
    onValuesChange?.(changedValues, allValues);
    setModified(true);
  };

  const handleBackClick = () => {
    if (showConfirmDataLoss && modified) {
      Modal.confirm({
        title: 'As modifições serão descartadas. Deseja sair sem salvar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Sair',
        cancelText: 'Cancelar',
        onOk() {
          cancelEdit();
        }
      });
    } else {
      cancelEdit();
    }
  };

  return (
    <PageContainer
      size={size}
      resource={resource}
      onOkClick={handleSubmit}
      onBackClick={handleBackClick}
      okButtonText="Salvar"
      backButtonText={readOnly ? 'Voltar' : 'Cancelar'}
      visible={visible}
      readOnly={readOnly}
      {...rest}
    >
      <ResourceErrorAlert resource={resource} />
      {React.cloneElement(children, {
        form: editingForm,
        onValuesChange: handleValuesChange,
        initialValues: !updateFormOnDataChanged
          ? onBeforeBinding
            ? onBeforeBinding(data)
            : data
          : undefined,
        ...configManager.getConfig().layout.form
      })}
    </PageContainer>
  );
};

export default PageEdit;
